export function obterVersao(): string {
    return "v3.1.0";
}

export function obterNomeEmpresa(): string {
    return "CargasSac";
}

export function obterIdProduto(): string {
    return "c4b1b457-5be9-4081-b2f8-06e85aa1bdd0";
}

export function formatarPorTipoPersonalizado(type: string, value: string): string {
    if (type) {
        switch (type) {
            case "statusCotacaoPreco":
                return formatarStatusCotacaoPreco(value);
            default:
                return value;
        }
    } else {
        return value;
    }
}

function formatarStatusCotacaoPreco(value: string): string {
    switch (value) {
        case "B":
            return "Baixada";
        case "C":
            return "Cancelada";
        case "F":
            return "Confirmada";
        case "AS":
            return "Aguardando sincronização";
        default:
            return "A Confirmar";
    }
}

export function apenasNumeros(value: string): string {
    return value.replace(/[^0-9]/g, '');
}